export default __webpack_public_path__ + "static/media/logo-invoice.b269fc67.png";